import { guidRegex } from 'infrastructure/regexp';

export const isValidGuid = (guid: string) => {
  return guidRegex.test(guid);
};
